var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mantra-format",attrs:{"id":"mantra-format"}},[_c('router-view',{on:{"show-gallery-upload":function($event){_vm.$emit('show-gallery-upload')},"show-take-picture":function($event){_vm.$emit('show-take-picture')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }